import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export type DtLoaderSize = "xtraSmall" |"small" | "medium" | "large";
export type DtLoaderMode = "global" | "local";

const sizeMap: Record<DtLoaderSize, number> = {
    xtraSmall: 16,
    small: 24,
    medium: 48,
    large: 72,
};

interface DtLoaderProps {
    size?: DtLoaderSize;
    sx?: object;
    message?: string;
    mode?: DtLoaderMode; // "global" or "local"
}

const DtLoader: React.FC<DtLoaderProps> = ({
    size = "medium",
    sx,
    message,
    mode = "local",
}) => {
    // For global mode, overlay the loader over the whole screen
    if (mode === "global") {
        return (
            <Box
                sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    bgcolor: "rgba(255,255,255,0.7)",
                    zIndex: 2000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    ...sx,
                }}
            >
                <CircularProgress size={sizeMap[size]} />
                {message && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                        {message}
                    </Typography>
                )}
            </Box>
        );
    }

    // Local mode (default)
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                width: "100%",
                height: "100%",
                ...sx,
            }}
        >
            <CircularProgress size={sizeMap[size]} />
            {message && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    {message}
                </Typography>
            )}
        </Box>
    );
};

export { DtLoader };